import React from 'react';
import './EducationPartners.css';

function EducationPartners() {
  return (
    <div className="edu-circle-logos">
      <div className="rs5865f2-titleWrap">
        <div className="rs5865f2-titleRow">
          <div className="rs5865f2-titlePlain">Awards & </div>
          <div className="rs5865f2-titleGradient">Recognition</div>
        </div>
        <div className="rs5865f2-gradientLine" />
      </div>

      {/* Replaced inline styles with a class name */}
      <div className="single-award-container">
        <img 
          src="/Awards/awards&achivements.png" 
          alt="Awards and Achievements" 
          className="single-award-image" 
          loading="lazy" 
        />
      </div>
    </div>
  );
}

export default EducationPartners;